/**
 * 안전자재(비-PPE) — 산업안전보건관리비 인정 안내 (보호구 배너와 동일 UI)
 */

export const COST_LINK_NA2 = {
  label: '건설업 산업안전보건관리비 고시 제7조제1항제2호 — 안전시설비 등',
  url: '/safety-regulations/qa-construction/intro#intro-na-2',
};

export const COST_LINK_NA3 = {
  label: '건설업 산업안전보건관리비 고시 제7조제1항제3호 — 보호구 등',
  url: '/safety-regulations/qa-construction/intro#intro-na-3',
};

export const COST_LINK_ART74 = {
  label: '산업안전보건법 시행령 제74조(보호구의 성능인증 등)',
  url: '/safety-regulations/003786/article/74',
};

/** 안전인증 대상 보호구 (안전대·연결줄·추락방지기 등) */
export function buildCertifiedPpeManagementCost(overrides = {}) {
  return {
    recognized: true,
    category: '안전인증 대상 보호구',
    note:
      overrides.note ||
      '영 제74조제1항제3호에 따른 안전인증(또는 자율안전확인)을 받은 품목의 구입·수리·관리 비용으로 사용할 수 있습니다.',
    links: overrides.links || [COST_LINK_ART74, COST_LINK_NA3],
    ...overrides,
  };
}

/** 안전난간·개구부 방호·추락방호망 등 안전시설 */
export function buildSafetyFacilityManagementCost(overrides = {}) {
  return {
    recognized: true,
    category: '안전시설비',
    note:
      overrides.note ||
      '산업재해 예방을 위한 안전시설의 구입·임대·설치 등에 소요되는 비용(고시 제7조제1항제2호)으로 사용할 수 있습니다.',
    links: overrides.links || [COST_LINK_NA2],
    ...overrides,
  };
}

/** 품목·현장별 확인이 필요한 경우 */
export function buildConditionalFacilityCost(overrides = {}) {
  return {
    recognized: true,
    limitedRecognition: true,
    category: '안전시설비 · 현장 확인',
    summary: overrides.summary || '안전시설비 항목으로 쓸 수 있는 경우가 많으나, 용도·설치 목적에 따라 질의회시·고시 해석이 달라질 수 있습니다.',
    confirmNote: overrides.confirmNote || '구입·설치 목적이 산업재해 예방인지, 작업발판·본공사 자재와 구분되는지 현장·질의회시로 확인하세요.',
    links: overrides.links || [COST_LINK_NA2],
    ...overrides,
  };
}
